import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
const IntelMsg = ({ id }) => {
  const { t } = useTranslation()
  return <>{t(id)}</>
}

export const IntelMsgPlaceholder = (id) => {
  const { t } = useTranslation()
  return t(id)
}

IntelMsg.propTypes = {
  id: PropTypes.string.isRequired,
}
export default IntelMsg
